// extracted by mini-css-extract-plugin
module.exports = {"mt5-section":"PlatformsMt5_mt5-section__Fd0x0","mt5-header":"PlatformsMt5_mt5-header__kAel8"};